import { useQuery } from "@tanstack/react-query"

import { getFeatures } from "@/services/portalApi"

const featureQueryKeys = {
  all: ["features"] as const,
}

// useFeatures reads the backend's runtime feature-flag state (e.g. whether the
// SQI coverage layer is enabled). Feature flags change only on redeploy, so the
// result is cached aggressively.
export function useFeatures() {
  return useQuery({
    queryKey: featureQueryKeys.all,
    staleTime: 1000 * 60 * 5,
    queryFn: getFeatures,
  })
}
